import api from './api';

export interface Enquiry {
  id: number;
  enquiry_no: string | null;
  enquiry_date: string | null;
  company_name: string | null;
  contact_person: string | null;
  street: string | null;
  town: string | null;
  district: string | null;
  contact_no: string | null;
  service_date: string | null;
  bore_size_id: number | null;
  is_confirmed: string | null;
  is_cancelled: string | null;
  created_by: number | null;
  updated_by: number | null;
  created_at: string | null;
  updated_at: string | null;
  pipe_rate: number | null;
  batta: number | null;
  user_id: number | null;
  assign_field_team: number | null;
  rig_id: number | null;
  pipe_rate_alt: number | null;
  location_coordinates: string | null;
  location_url: string | null;
  boreSize?: {
    id: number;
    size: string;
    type: 'FEET' | 'FIXED';
  };
  createdByUser?: {
    id: number;
    name: string;
    username: string;
  };
  updatedByUser?: {
    id: number;
    name: string;
    username: string;
  };
  assignedUser?: {
    id: number;
    name: string;
    username: string;
    mobile: string;
  };
  assignedFieldTeam?: {
    id: number;
    name: string;
    username: string;
    mobile: string;
  };
  rig?: {
    id: number;
    rig_no: string;
  };
}

export interface EnquiryFormData {
  company_name?: string;
  contact_person?: string;
  street?: string;
  town?: string;
  district?: string;
  contact_no?: string;
  service_date?: string;
  bore_size_id?: number;
  pipe_rate?: number;
  batta?: number;
  user_id?: number;
  assign_field_team?: number;
  rig_id?: number;
  pipe_rate_alt?: number;
  location_coordinates?: string;
  location_url?: string;
}

export interface EnquiriesResponse {
  enquiries: Enquiry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface EnquiryFilters {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'confirmed' | 'cancelled' | 'pending' | 'site_visited';
  userId?: number;
  boreSizeId?: number;
  createdById?: number;
  updatedById?: number;
  serviceDateFrom?: string;
  serviceDateTo?: string;
  enquiryDateFrom?: string;
  enquiryDateTo?: string;
  sortBy?: 'created_at' | 'enquiry_date' | 'service_date' | 'enquiry_no';
  sortOrder?: 'asc' | 'desc';
  unmapped?: boolean;
  without_invoice?: string;
}

class EnquiryService {
  async getEnquiries(filters: EnquiryFilters = {}): Promise<EnquiriesResponse> {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, String(value));
      }
    });

    const response = await api.get(`/enquiries?${params}`);
    return response.data;
  }

  async getEnquiry(id: number): Promise<Enquiry> {
    const response = await api.get(`/enquiries/${id}`);
    return response.data;
  }

  async createEnquiry(data: EnquiryFormData): Promise<Enquiry> {
    const response = await api.post('/enquiries', data);
    return response.data.enquiry;
  }

  async updateEnquiry(id: number, data: EnquiryFormData): Promise<Enquiry> {
    const response = await api.put(`/enquiries/${id}`, data);
    return response.data.enquiry;
  }

  async deleteEnquiry(id: number): Promise<void> {
    await api.delete(`/enquiries/${id}`);
  }


}

const enquiryService = new EnquiryService();
export default enquiryService;